import React from 'react';
import CenterImage from './../CenterImage/CenterImage';

const EditProfileImage = () => (
  <CenterImage
    image={
      <svg
        width="128px"
        height="128px"
        viewBox="0 0 128 128"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <defs>
          <mask
            id="mask-2"
            maskContentUnits="userSpaceOnUse"
            maskUnits="objectBoundingBox"
            x="0"
            y="0"
            width="128"
            height="128"
            fill="white"
          >
            <use xlinkHref="#path-1"></use>
          </mask>
        </defs>
        <g
          id="Illustration-Library"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g
            id="extended-illustration"
            transform="translate(-211.000000, -1752.000000)"
          >
            <g
              id="ic_ex_profile-editing"
              transform="translate(211.000000, 1752.000000)"
            >
              <g
                id="ic_settings_156x156-copy"
                transform="translate(14.000000, 13.000000)"
                stroke="#DFEBEB"
                strokeLinecap="round"
                strokeWidth="6"
              >
                <g id="setting" transform="translate(0.010230, 0.250887)">
                  <path
                    d="M51.8677881,0.749113109 C52.7379724,0.749113109 53.5082949,1.31176896 53.7730047,2.14071378 L56.7593366,11.4922725 C60.6084689,13.0306988 64.1344002,15.2329984 67.2036756,17.9621622 C69.4606859,17.4713988 72.8285661,16.7291945 77.305364,15.7363532 C78.1576004,15.5473601 79.0339633,15.932929 79.4704336,16.6889177 L87.3371228,30.3144232 C87.772215,31.0680249 87.670102,32.0164717 87.0845696,32.6601895 L79.3068649,41.2115689 C79.4857765,42.7008993 79.5779091,44.2178175 79.5779091,45.7568275 C79.5779091,47.540593 79.4541418,49.2946814 79.2149427,51.0105352 L78.124333,49.7910211 C81.1172874,53.1405035 84.1102419,56.4899858 87.1031964,59.8394682 C87.6786564,60.4834784 87.7757192,61.4241318 87.3438908,62.1720807 L79.4507299,75.8434363 C79.0236118,76.5832467 78.1737587,76.9700985 77.3353429,76.8063661 C71.9051029,75.7459065 68.1467321,74.9851966 66.0602304,74.5242363 C63.4077569,76.6951703 60.4467163,78.4860955 57.256329,79.8183111 L57.9938571,77.5742121 C56.5895975,81.8409278 55.185338,86.1076436 53.7810784,90.3743594 C53.5110792,91.1947275 52.7449808,91.7491131 51.8813239,91.7491131 L36.0950022,91.7491131 C35.2407486,91.7491232 34.4807985,91.2065547 34.203387,90.3985991 C32.5423721,85.5609258 31.3739189,82.0887454 30.6980272,79.9820578 C27.3546869,78.6367383 24.2570118,76.7882239 21.4923796,74.528558 L23.86767,74.0323041 C19.470456,74.9495375 15.0732419,75.8667709 10.6760278,76.7840043 C9.83056867,76.9603622 8.96740749,76.5740944 8.53557902,75.8261455 L0.642418183,62.1547899 C0.215282637,61.4149896 0.305185717,60.4855693 0.866190008,59.8413461 C4.41881689,55.7617256 6.92414611,52.9229699 8.38217766,51.3250791 C8.11165061,49.5097015 7.97223838,47.6499788 7.97223838,45.7568275 C7.97223838,44.0559289 8.08477324,42.3820142 8.30261613,40.7425026 C6.76110464,39.042473 4.29945501,36.3483727 0.919711587,32.660596 C0.329920545,32.0170342 0.225651573,31.0652972 0.662121867,30.3093085 L8.5288111,16.6838031 C8.96390327,15.9302013 9.83633876,15.5444104 10.6865809,15.7296374 L20.4629027,17.8590791 C23.6499196,15.0495849 27.323827,12.8057681 31.3368824,11.2793056 C32.0299368,9.10542627 32.9933543,6.06128091 34.2269297,2.14783612 C34.4893751,1.31528119 35.261469,0.749113109 36.1344096,0.749113109 L51.8677881,0.749113109 Z"
                    id="Combined-Shape-Copy"
                  ></path>
                  <path
                    d="M43.9897698,31.7491131 C36.2577833,31.7491131 29.9897698,38.0171266 29.9897698,45.7491131 C29.9897698,53.4810996 36.2577833,59.7491131 43.9897698,59.7491131 C51.7217563,59.7491131 57.9897698,53.4810996 57.9897698,45.7491131 C57.9897698,43.4225923 57.4222753,41.2286169 56.4181607,39.2980612"
                    id="Oval-5-Copy-2"
                    transform="translate(43.989770, 45.749113) rotate(-330.000000) translate(-43.989770, -45.749113) "
                  ></path>
                </g>
              </g>
              <g
                id="Group-2"
                opacity="0.871206975"
                stroke="#C1C1C1"
                strokeDasharray="2"
                strokeLinejoin="round"
                strokeWidth="2"
              >
                <g id="Group">
                  <use
                    id="base_128x128"
                    mask="url(#mask-2)"
                    xlinkHref="#path-1"
                  ></use>
                </g>
              </g>
              <g id="Group-17" transform="translate(58.000000, 63.000000)">
                <g id="ic_user_account_64x64">
                  <polygon
                    id="white-background"
                    fill="#FFFFFF"
                    points="1 1 54 1 54 39 1 39"
                  ></polygon>
                  <g
                    id="text"
                    transform="translate(34.000000, 13.000000)"
                    fill="#365568"
                  >
                    <path
                      d="M1,0 L11,0 C11.5522847,-1.01453063e-16 12,0.44771525 12,1 C12,1.55228475 11.5522847,2 11,2 L1,2 C0.44771525,2 6.76353751e-17,1.55228475 0,1 C-6.76353751e-17,0.44771525 0.44771525,1.01453063e-16 1,0 Z"
                      id="Rectangle-26"
                    ></path>
                    <path
                      d="M6,4 L11,4 C11.5522847,4 12,4.44771525 12,5 C12,5.55228475 11.5522847,6 11,6 L6,6 C5.44771525,6 5,5.55228475 5,5 C5,4.44771525 5.44771525,4 6,4 Z"
                      id="Rectangle-26-Copy"
                    ></path>
                    <path
                      d="M9,8 L11,8 C11.5522847,8 12,8.44771525 12,9 C12,9.55228475 11.5522847,10 11,10 L9,10 C8.44771525,10 8,9.55228475 8,9 C8,8.44771525 8.44771525,8 9,8 Z"
                      id="Rectangle-26-Copy-2"
                    ></path>
                  </g>
                  <path
                    d="M38,3 L50.9428212,3 L50.9428219,19.8088912 C50.9428219,19.8088912 50.5218746,11.3387072 47.4199431,7.3990781 C44.3180117,3.45944899 38,3 38,3 Z"
                    id="shadow"
                    fill="#DFEBEB"
                  ></path>
                  <path
                    d="M-2.04636308e-12,30.3895172 L-2.04636308e-12,0 L54,0 L54,20.1419956 L54,38 L20.8194504,38 M2.81291636,38 L-2.04636308e-12,38 L-2.04636308e-12,27.9149416"
                    id="Path-2"
                    stroke="#365568"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    transform="translate(27.000000, 19.000000) scale(-1, 1) translate(-27.000000, -19.000000) "
                  ></path>
                  <g id="profil" transform="translate(7.000000, 10.000000)">
                    <path
                      d="M11.4904385,12.6536697 C18.1887997,12.6536697 18.8379205,15.5293063 18.8379205,15.5293063 C18.8379205,15.5293063 13.8850895,19.1262101 10.7033639,19.1238521 C7.52163835,19.121494 4.34254487,18.4049429 3.20841098,18.4049429 C0.97562391,18.4049429 4.7920773,12.6536697 11.4904385,12.6536697 Z"
                      id="Path-86-Copy"
                      fill="#7FBABA"
                    ></path>
                    <path
                      d="M0.642201835,16.6192661 C0.642201835,16.6192661 3.62052918,11.4013761 9.57718389,11.4013761 C15.5338386,11.4013761 17.7675841,14.3830275 17.7675841,14.3830275"
                      id="Path-86"
                      stroke="#365568"
                      strokeWidth="2"
                      strokeLinecap="round"
                    ></path>
                    <ellipse
                      id="Combined-Shape"
                      fill="#7FBABA"
                      cx="11.382263"
                      cy="5.66169725"
                      rx="3.74617737"
                      ry="3.65252294"
                    ></ellipse>
                    <circle
                      id="Combined-Shape-Copy"
                      stroke="#365568"
                      strokeWidth="2"
                      cx="9.5"
                      cy="4.5"
                      r="3.5"
                    ></circle>
                  </g>
                </g>
                <g
                  id="pen"
                  transform="translate(40.781089, 36.781089) rotate(-30.000000) translate(-40.781089, -36.781089) translate(36.281089, 13.781089)"
                >
                  <path
                    d="M5.83012702,5.3660254 L5.83012702,9.3660254 L6.83012702,9.3660254 L6.83012702,42.3660254 C6.83012702,44.0228797 5.48698127,45.3660254 3.83012702,45.3660254 C2.17327277,45.3660254 0.830127019,44.0228797 0.830127019,42.3660254 L0.830127019,9.3660254 L1.83012702,9.3660254 L1.83012702,5.3660254 L5.83012702,5.3660254 Z"
                    id="Combined-Shape"
                    fill="#7FBABA"
                  ></path>
                  <path
                    d="M2.83012702,8.3660254 L8.83012702,8.3660254 L8.83012702,42.3660254 C8.83012702,44.0228797 7.48698127,45.3660254 5.83012702,45.3660254 C4.17327277,45.3660254 2.83012702,44.0228797 2.83012702,42.3660254 L2.83012702,8.3660254 L2.83012702,8.3660254 Z"
                    id="Rectangle-81"
                    stroke="#365568"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                  <rect
                    id="Rectangle-53"
                    stroke="#365568"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    x="3.83012702"
                    y="4.3660254"
                    width="4"
                    height="4"
                  ></rect>
                  <line
                    x1="2.83012702"
                    y1="38.3660254"
                    x2="7.83012702"
                    y2="38.3660254"
                    id="Path-131"
                    stroke="#365568"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></line>
                  <path
                    d="M5.83012702,0.366025404 C6.38241177,0.366025404 6.83012702,0.813740654 6.83012702,1.3660254 L6.83012702,4.3660254 L6.83012702,4.3660254 L4.83012702,4.3660254 L4.83012702,1.3660254 C4.83012702,0.813740654 5.27784227,0.366025404 5.83012702,0.366025404 Z"
                    id="Rectangle-82"
                    fill="#365568"
                  ></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    }
  />
);

export default EditProfileImage;
